import { initials } from "@dicebear/collection";
import { createAvatar } from "@dicebear/core";

export const getAvatarPlaceholderUrl = (seed: string) => {
  return createAvatar(initials, {
    seed,
    backgroundType: ["gradientLinear"],
    scale: 85,
  }).toDataUri();
};
